export default __webpack_public_path__ + "static/media/hht1_ep3_minisitcom_04.d581dd89.png";